import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

type TonRouteChangeCallback = () => void;

const useRouteChange = (func: TonRouteChangeCallback) => {
  const pathname = usePathname();
  useEffect(() => func(), [pathname]);
  return null;
};

export { useRouteChange };
